
interface OrganizationData {
  id?: number;
  ownerId?: number;
  code?: string;
  name?: string;
  image?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;
}

export class Organization {
  public static getNonTranslatableFields(): string[] { return ['id', 'ownerId', 'code', 'name', 'image', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'ownerId', 'code', 'name', 'image', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  ownerId?: number;
  code?: string;
  name?: string;
  image?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;


  public static fromAPI(data: OrganizationData): Organization {
    return new Organization(data);
  }

  public static fromAPIList(data: OrganizationData[]): Organization[] {
    return data.map((item: OrganizationData) => Organization.fromAPI(item));
  }

  constructor({id,ownerId,code,name,image,createDate,createrId,updateDate,updaterId,deleteDate,deleterId} : OrganizationData) {
    this.id = id;
    this.ownerId = ownerId;
    this.code = code;
    this.name = name;
    this.image = image;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
  }

  public toJson(): Object {
    return {
      id: this.id,
      ownerId: this.ownerId,
      code: this.code,
      name: this.name,
      image: this.image,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
